<bc-modal #modalConf [customWidth]="'small'" [isCancellable]="false" textBtn="Entendido" [hideCloseButton]="false"
    [displayButton]="false" [buttonAlignment]="'vertical'" (stateClick)="onPressButton($event)"
    (closeModalEvent)="cerrarModal()">
    <div modalContent>
        <div class="content">
            <div class="header-text">
                <bc-icon aria-hidden="true" [name]="'theory'" [aria-label]="" role="img" [width]=""
                    class="bc-sm"></bc-icon>
                <h4>Queremos llamarte
                    y no tenemos tu número</h4>
                <p>
                    Actualiza tu información de contacto. En nuestra Sucursal Virtual Personas, elige la opción
                    “Actualizar mis datos”. La encontrarás justo debajo de tu nombre.
                    <br>
                    <br>
                    Luego de actualizar tu información. Abre tu App Bancolombia e ingresa de nuevo.
                </p>
            </div>
        </div>
    </div>
</bc-modal>